$(document).ready(function() {
  var timeout = null;

  reloadCheckoutPage(timeout);
  const callreloadCheckoutPage = () => reloadCheckoutPage(timeout);
  window.callreloadCheckoutPage = callreloadCheckoutPage;
});

function reloadCheckoutPage(timeout){
  window.addEventListener( "pageshow", function ( event ) {
    var historyTraversal = event.persisted || 
                          ( typeof window.performance != "undefined" && 
                                window.performance.navigation.type === 2 );

    const d = new Date();
    let time = d.getTime();

    var startDate = new Date(time * 1000);
    var endDate   = new Date();
    var seconds = (endDate.getTime() - startDate.getTime());
    var expired = seconds > 1000 * 60 * 3; // 3 minutes

    if ( historyTraversal && expired ) {
      // Handle page reload.
      window.location.reload();
    }
  });
}
